import Script from 'next/script';
import { getEnvs } from '@/helpers/getEnvs';
const appEnvironment = getEnvs()?.APP_ENVIRONMENT;
const isWhiteLabel = appEnvironment === 'violet';
const GTMLoader = () => {
  return !isWhiteLabel && <Script id="google-tag-manager" strategy="beforeInteractive" defer>
        {`(function (w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
              var f = d.getElementsByTagName(s)[0],
                  j = d.createElement(s),
                  dl = l != "dataLayer" ? "&l=" + l : "";
                j.async = true;
              j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
              f.parentNode.insertBefore(j, f);
              })(window, document, "script", "dataLayer", "GTM-NDN3DQ7");`}
      </Script>;
};
export default GTMLoader;

// enum GTM {
//   GUEST = 'GTM-NDN3DQ7',
//   HOST = 'GTM-5DHHRTJ6',
// }
//
// const initialRoute =
//   typeof window !== 'undefined' ? window.location.pathname : ''
//
// const initialGtmId = initialRoute?.startsWith('/panel/host')
//   ? GTM.HOST
//   : GTM.GUEST

// const router = useRouter()
// const [gtmId, setGtmId] = useState(initialGtmId)
//
// useEffect(() => {
//   const handleRouteChange = url => {
//     setGtmId(url?.startsWith('/panel/host') ? GTM.HOST : GTM.GUEST)
//   }
//
//   router.events.on('routeChangeComplete', handleRouteChange)
//   return () => {
//     router.events.off('routeChangeComplete', handleRouteChange)
//   }
// }, [router.events])

// <Script
//   id="google-tag-manager"
//   strategy="lazyOnload"
//   async={true}
//   defer={true}
// >
//   {`(function (w, d, s, l, i) {
//     w[l] = w[l] || [];
//     w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
//     var f = d.getElementsByTagName(s)[0],
//         j = d.createElement(s),
//         dl = l != "dataLayer" ? "&l=" + l : "";
//     j.async = true;
//     j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
//     f.parentNode.insertBefore(j, f);
//     })(window, document, "script", "dataLayer", "${gtmId}");`}
// </Script>